const Button = ({
  children,
  size = 'md',
  variant = 'primary',
  disabled = false,
  isLoading = false, // New Prop
  onClick,
  className,
}) => {
  const sizes = {
    md: 'h-10 lg:h-[48px]',
  }

  const variants = {
    primary: 'bg-primary text-white! border-transparent',
    secondary: 'bg-secondary! text-white! border-transparent',
    tertiary: 'bg-[#FDF0E9]! text-primary! border-[#E6E6E6] border',
    whitelabel: 'bg-black! text-white!',
  }

  const dotColor = variant === 'tertiary' ? 'bg-primary' : 'bg-white'

  return (
    <button
      onClick={!disabled && !isLoading ? onClick : undefined}
      disabled={disabled || isLoading}
      className={`
        relative flex items-center justify-center
        w-full px-4! outline-none! active:outline-none! font-bold! rounded-lg transition-colors
        ${sizes[size]} 
        ${variants[variant]}
        ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:cursor-pointer hover:opacity-90'}
        ${className ?? ''}
      `}
    >
      {isLoading ? (
        <div className="flex items-center gap-1">
          <span
            className={`w-1.5 h-1.5 rounded-full animate-wave ${dotColor}`}
            style={{ animationDelay: '0ms' }}
          />
          <span
            className={`w-1.5 h-1.5 rounded-full animate-wave ${dotColor}`}
            style={{ animationDelay: '150ms' }}
          />
          <span
            className={`w-1.5 h-1.5 rounded-full animate-wave ${dotColor}`}
            style={{ animationDelay: '300ms' }}
          />
        </div>
      ) : (
        children
      )}
    </button>
  )
}

export default Button
